class Ticker extends HTMLElement {
    constructor() {
        super();
        this.locationsJson = JSON.parse(this.querySelector('[data-ticker-json]').innerHTML);
        this.locationsJson.forEach((location) => this.fetchTime(location));
    }

    createTickerEl(location, time, link) {
        let tickerItemTemplate = `
            ${link !== null 
            ? `<a href=${link}> </a>`
            : ''
            }
            <span>${location}</span>
        `
        let locationItem = document.createElement('p')
        let citySpan = document.createElement('span')
        citySpan.innerHTML = location;
        let itemContent = document.createTextNode(time)

        // console.log(itemContent)

        locationItem.innerHTML = tickerItemTemplate
        locationItem.appendChild(itemContent)        
        return locationItem
    }


    // fetchTime(location) {
    //     let currentDateTime = new Date()

    //     try {
    //         let locationTime = new Intl.DateTimeFormat('en-GB', { timeStyle: 'short', timeZone: location.IANATimezoneName }).format(currentDateTime);

    //         let newLocation = this.createTickerEl(location.location, locationTime, location.link)
    //         this.appendChild(newLocation)
    //     } catch (e) {
    //         console.error("Invalid timezone:", timezone, e);
    //     }
    // }

    fetchTime(location) {
        let currentDateTime = new Date();
        let locationTime = '';
    
        try {
            // Attempt to format the time using the location's timezone
            locationTime = new Intl.DateTimeFormat('en-GB', { timeStyle: 'short', timeZone: location.IANATimezoneName }).format(currentDateTime);
        } catch (e) {
            // If invalid timezone, log the error and leave locationTime as an empty string
            console.error(`Invalid timezone: ${location.IANATimezoneName}. Skipping...`);
        }
    
        // Only proceed if the timezone was valid and locationTime was set
        if (locationTime) {
            let newLocation = this.createTickerEl(location.location, locationTime, location.link);
            this.appendChild(newLocation);
        } else {
            // Optionally handle invalid timezone case here
            console.log(`Location '${location.location}' has an invalid timezone. No time displayed.`);
        }
    }
    
}
window.customElements.define('ticker-component', Ticker);